<script lang="ts">
	import { ICONS, type IconName } from '../icons.js';

	interface Props {
		name: IconName;
		/** Размер стороны в пикселях. По умолчанию 24 — базовая сетка набора. */
		size?: number;
		/** Толщина линии. Для мелких размеров имеет смысл увеличивать. */
		strokeWidth?: number;
		/** Заливка вместо обводки — для сплошных иконок вроде «play». */
		filled?: boolean;
		class?: string;
	}

	let { name, size = 24, strokeWidth = 2, filled = false, class: className = '' }: Props = $props();
</script>

<!--
	Иконка наследует цвет текста родителя через currentColor,
	поэтому отдельно её красить не нужно — она сама подходит обеим темам.
-->
<svg
	class="icon {className}"
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill={filled ? 'currentColor' : 'none'}
	stroke={filled ? 'none' : 'currentColor'}
	stroke-width={strokeWidth}
	stroke-linecap="round"
	stroke-linejoin="round"
	aria-hidden="true"
	focusable="false"
>
	{@html ICONS[name]}
</svg>

<style>
	.icon {
		display: block;
		flex-shrink: 0;
	}
</style>
